import { Observable } from 'rxjs';
import { ShipmentTransportOrderTrackingMapStateModel } from './shipment-transport-order-tracking-map.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  ShipmentTransportOrderTrackingMapLoad,
  ShipmentTransportOrderTrackingMapInitialState,
} from './shipment-transport-order-tracking-map.actions';
import { ShipmentTransportOrderTrackingMapState } from './shipment-transport-order-tracking-map.state';
import { ShipmentTransportOrderMapData } from '../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderTrackingMapFacade implements LoadDataFacade, SetInitialStateFacade {
  state$: Observable<ShipmentTransportOrderTrackingMapStateModel> = this.store.select(
    ShipmentTransportOrderTrackingMapState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderTrackingMapState.getLoaded);
  mapData$: Observable<ShipmentTransportOrderMapData> = this.store.select(
    ShipmentTransportOrderTrackingMapState.getMapData,
  );

  constructor(private store: Store) {}

  loadAll(transportOrderNumber: number): void {
    this.store.dispatch(new ShipmentTransportOrderTrackingMapLoad(transportOrderNumber));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderTrackingMapInitialState());
  }
}
